import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminServicesService } from '../../core/services/admin-services.service';
import { AdminService } from '../../core/models/admin.models';
import { ModalComponent } from '../../shared/components/ui/modal/modal.component';
import { ServiceFormComponent } from '../service-form/service-form.component';

@Component({
  selector: 'app-services-list',
  standalone: true,
  imports: [CommonModule, ModalComponent, ServiceFormComponent],
  templateUrl: './services-list.component.html'
})
export class ServicesListComponent implements OnInit {
  servicesList: AdminService[] = [];
  isLoading = false;
  errorMessage = '';

  isModalOpen = false;
  selectedService: AdminService | null = null;

  constructor(private servicesService: AdminServicesService) {}

  ngOnInit() {
    this.loadServices();
  }

  loadServices() {
    this.isLoading = true;
    this.errorMessage = '';

    this.servicesService.getServices().subscribe({
      next: (res) => {
        this.servicesList = Array.isArray(res) ? res : (res as any).data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load services.';
        this.isLoading = false;
      }
    });
  }

  openCreateModal() {
    this.selectedService = null;
    this.isModalOpen = true;
  }

  openEditModal(service: AdminService) {
    this.selectedService = service;
    this.isModalOpen = true;
  }

  handleSave(data: Partial<AdminService>) {
    const action$ = this.selectedService 
        ? this.servicesService.updateService(this.selectedService.id, data)
        : this.servicesService.createService(data);

    action$.subscribe({
      next: () => {
        this.isModalOpen = false;
        this.loadServices();
      },
      error: (err) => alert(err?.error?.message ?? 'Action failed.')
    });
  }

  deleteService(id: number) {
    if(confirm('Are you sure you want to delete this service?')) {
      this.servicesService.deleteService(id).subscribe({
        next: () => this.loadServices(),
        error: (err) => alert(err?.error?.message ?? 'Failed to delete service.')
      });
    }
  }
}
